var _circle, _mask, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetails1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "white",
    stroke: "#F1F1F1",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C13.1748 -3.36903e-08 10.4 0.748072 7.95759 2.16817C5.51523 3.58826 3.49243 5.62973 2.09484 8.08504C0.697252 10.5404 -0.0252881 13.322 0.00067567 16.147C0.0266395 18.9721 0.800181 21.74 2.24266 24.1692L3.94858 23.1562C2.68497 21.0282 2.00734 18.6036 1.9846 16.1288C1.96186 13.654 2.5948 11.2174 3.81909 9.0665C5.04337 6.91565 6.81534 5.12732 8.95485 3.88332C11.0944 2.63932 13.5251 1.98401 16 1.98401V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C13.1748 -3.36903e-08 10.4 0.748072 7.95759 2.16817C5.51523 3.58826 3.49243 5.62973 2.09484 8.08504C0.697252 10.5404 -0.0252881 13.322 0.00067567 16.147C0.0266395 18.9721 0.800181 21.74 2.24266 24.1692L3.94858 23.1562C2.68497 21.0282 2.00734 18.6036 1.9846 16.1288C1.96186 13.654 2.5948 11.2174 3.81909 9.0665C5.04337 6.91565 6.81534 5.12732 8.95485 3.88332C11.0944 2.63932 13.5251 1.98401 16 1.98401V0Z",
    stroke: "#50949E",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 22.6668C19.6825 22.6668 22.6673 19.6821 22.6673 16.0002C22.6673 12.3183 19.6825 9.3335 16.0007 9.3335C12.3188 9.3335 9.33398 12.3183 9.33398 16.0002C9.33398 19.6821 12.3188 22.6668 16.0007 22.6668Z",
    stroke: "#32425B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.6667V16",
    stroke: "#32425B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.3335H16.007",
    stroke: "#32425B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails1);
export default __webpack_public_path__ + "static/media/details1.a6eb11554372becf8514f933cb07ac08.svg";
export { ForwardRef as ReactComponent };